import React from "react";
import { COBERTURA } from "../data/team";
import { IconeWhatsApp } from "./Icones";

/**
 * O cartão que responde a única pergunta urgente do app:
 * quem eu ligo agora, e para quem eu escalo se não atender.
 */
export default function PlantaoAgora({ plantao }) {
  const { pessoa, dataLonga, diaSemanaLongo, fimDeSemana, feriado, troca } =
    plantao;

  return (
    <section className="agora" aria-labelledby="agora-titulo">
      <div className="agora__foto">
        <img src={pessoa.foto} alt="" />
      </div>

      <div className="agora__info">
        <p className="agora__status">
          <span className="pulso" aria-hidden="true" />
          De plantão agora
        </p>

        <h1 id="agora-titulo" className="agora__nome">
          {pessoa.nome}
        </h1>

        <p className="agora__data">
          <span className="agora__data-forte">{diaSemanaLongo}</span>
          <span className="ponto" aria-hidden="true">
            ·
          </span>
          {dataLonga}
        </p>

        {(fimDeSemana || feriado || troca) && (
          <ul className="selos" aria-label="Características do dia">
            {feriado && <li className="selo selo--pesado">{feriado}</li>}
            {fimDeSemana && !feriado && (
              <li className="selo selo--pesado">Fim de semana</li>
            )}
            {troca && (
              <li className="selo selo--troca">
                Troca combinada{troca.motivo ? ` · ${troca.motivo}` : ""}
              </li>
            )}
          </ul>
        )}

        <a
          className="botao botao--principal"
          href={pessoa.whatsapp}
          target="_blank"
          rel="noreferrer"
        >
          <IconeWhatsApp size={20} />
          Chamar {pessoa.primeiroNome} no WhatsApp
        </a>

        <p className="agora__cobertura">
          <strong>{COBERTURA.titulo}.</strong> {COBERTURA.detalhe}
        </p>
      </div>
    </section>
  );
}
